import React from 'react';
import { Link } from "react-router-dom";

export const LensDetailLeft = () => {
    return (
        <>
            <div className="w-full lg:w-2/3 py-8">
                <ul className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <li className="border border-gray-200 rounded-md overflow-hidden"><Link to="#"><img src="images/lens-1.jpeg" alt="Lens" className="hover:scale-110 transition duration-500" /></Link></li>
                    <li className="border border-gray-200 rounded-md overflow-hidden"><Link to="#"><img src="images/lens-2.jpeg" alt="Lens" className="hover:scale-110 transition duration-500"/></Link></li>
                    <li className="border border-gray-200 rounded-md overflow-hidden"><Link to="#"><img src="images/lens-3.jpeg" alt="Lens" className="hover:scale-110 transition duration-500"/></Link></li>
                </ul>
            </div>
        </>
    )
}